import { render, staticRenderFns } from "./CategoriesDirectory.vue?vue&type=template&id=2d2a79f1"
import script from "./CategoriesDirectory.vue?vue&type=script&lang=js"
export * from "./CategoriesDirectory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports